<template>
    <div class="py-8">
        <dashboard-property
            :property="property"
            :section_route="section_route"
        ></dashboard-property>
    </div>
</template>

<script>
import DashboardProperty from './dashboard-property.vue';

export default {
    components: {
        DashboardProperty,
    },

    props: {
        property: {},
        section_route: {},
    },
}
</script>
